/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'Block';

const classes = {
  labelBox: `${PREFIX}-labelBox`,
  label: `${PREFIX}-label`,
};

const Root = styled(Box)(({theme}) => ({
  width: '100%',

  [`& .${classes.labelBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 4),
    userSelect: 'none',
  },

  [`& .${classes.label}`]: {
    color: theme.palette.figma_gray_dark_5?.main,
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.12px',
  },
}));

export {Root as BlockRoot, classes as blockClasses};
